require('./services/diyfeatures');
require('./services/diyglobalevents');
require('./services/diyl10n');
require('./services/diywebsiteid');



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/angular/autoload.js
 ** module id = 878
 ** module chunks = 0
 **/